function Navigation() {

	const menu = document.querySelectorAll('[js-hook-menu]')[0];
	const btnOpen = document.querySelectorAll('[js-hook-menu-open]')[0];
	const btnClose = document.querySelectorAll('[js-hook-menu-close]')[0];
	const activeClass = 'active';

	btnOpen.addEventListener('click', function() {
		menu.classList.add(activeClass);
	}, false);

	btnClose.addEventListener('click', function() {
		menu.classList.remove(activeClass);
	}, false);
}

export default Navigation;






// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/dudok.test/frontend/source/components/navigation/javascript/navigation.js